import RoutineDaysOfWeek from './RoutineDaysOfWeek';
import RoutineTimeBoundaries from './RoutineTimeBoundaries';
import RoutineTrigger from './RoutineTrigger';
import Container from 'components/ui/Container';

const CustomRoutineOptions = () => (
  <Container
    variant='none'
    className='w-full flex items-center ~gap-x-2/4 ~gap-y-2/4 flex-wrap'
    data-testid='custom-routine-options-wrapper'>
    <RoutineTrigger />
    <RoutineTimeBoundaries>
      <RoutineDaysOfWeek />
    </RoutineTimeBoundaries>
  </Container>
);

export default CustomRoutineOptions;
